import React from 'react';
import moment from 'moment';
import FormWrapper from '../../../common/formComponents/FormWrapper/FormWrapper';
import { fieldNames, HOUR_INTERVAL_ID } from './constants';
import DatePickerRow from './components/DatePickerRow';
import IncludeWeekendRow from './components/IncludeWeekendRow';
import IntervalIdRow from './components/IntervalIdRow';
import TimeFieldsRow from './components/TimeFieldsRow';
import WithLunchBreakRow from './components/WithLunchBreakRow';
import LunchTimeFieldRow from './components/LunchTimeFieldsRow';
import WorkerIdsRow from './components/WorkerIdsRow';

const HouseAcceptanceNoticeForm = ({ form }) => {
  const withLunchBreakVal = form.getFieldValue(fieldNames.withLunchBreak);

  const checkMinutesMatchInterval = (_rule, value, callback) => {
    const intervalId = form.getFieldValue(fieldNames.intervalId);

    if (value && intervalId) {
      const minutes = moment(value).minutes();

      if (intervalId === HOUR_INTERVAL_ID && minutes !== 0) {
        return callback(
          'Укажите время без минут или измените продолжительность приемки на 30 минут'
        );
      }
    }
    return callback();
  };

  return (
    <FormWrapper>
      <DatePickerRow form={form} />
      <IncludeWeekendRow form={form} />
      <IntervalIdRow form={form} />
      <TimeFieldsRow
        form={form}
        checkMinutesMatchInterval={checkMinutesMatchInterval}
      />

      <WithLunchBreakRow form={form} />
      {withLunchBreakVal && (
        <LunchTimeFieldRow
          form={form}
          checkMinutesMatchInterval={checkMinutesMatchInterval}
        />
      )}

      <WorkerIdsRow form={form} />
    </FormWrapper>
  );
};

export default HouseAcceptanceNoticeForm;
